import axios from 'axios';
import { API_GET_USER, WapiRoles } from '../../constants';
import Vue from 'vue';

export default {
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    user: {},
    check: false,
    isContract: false,
    isRadarContract: false,
    contractInfo: null,
    radarContract: null
  },
  mutations: {
    AUTH_SUCCESS: (state, payload) => {
      state.token = payload;
    },
    SET_LOGGED_USER: (state, payload) => {
      state.user = payload;
    },
    SET_TOKEN: (state, payload) => {
      state.token = payload;
    },
    SET_CHECK: (state, payload) => {
      state.check = payload;
    },
    SET_IS_RADAR_CONTRACT: (state, payload) => {
      state.isRadarContract = payload;
    },
    SET_IS_CONTRACT: (state, payload) => {
      state.isContract = payload;
    },
  },
  actions: {
    LOGIN: async (context, payload) => {
      try {
        const authEndpoint = Vue.prototype.$settings.VUE_APP_AUTH_SERVICE_ENDPOINT;
        let loginResponse = await axios.post(`${authEndpoint}/auth2/1.1/connect/token`, payload);
        const token = loginResponse.data.result.access_token;
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        localStorage.setItem('token', token);
        context.commit('AUTH_SUCCESS', token);
        let userResponse = await axios.get(API_GET_USER);
        context.commit('SET_LOGGED_USER', userResponse.data.result);
        if (userResponse.data.result.role === WapiRoles.Admin) return { result: true };
        
        if (!(await context.dispatch('CHECK_CONTRACT'))) {          
          return { result: false, message: 'Account not activate.' };    
        }

        await context.dispatch('CHECK_RADAR_CONTRACT');
        return { result: true };
      } catch (err) {
        return { result: false, message: 'Введен неверный логин или пароль.' };    
      }
    },
    CHECK_CONTRACT: async (context) => {
      try {
        const contractInfo = await context.dispatch('FETCH_CONTRACT_INFO');
        if (contractInfo) {
          if (!contractInfo.status)
          {
            context.commit('SET_IS_CONTRACT', false);
            return false;
          } 
          context.commit('SET_IS_CONTRACT', true);
          return true;
        }
        return false;
      } catch (err) {
        context.commit('SET_IS_CONTRACT', false);
        return false;
      }
    },
    CHECK_RADAR_CONTRACT: async (context) => {
      try {
        const contractInfo = await context.dispatch('FETCH_RADAR_INFO');
        if (contractInfo) {
          context.commit('SET_IS_RADAR_CONTRACT', true);
          return true;
        } else {
          context.commit('SET_IS_RADAR_CONTRACT', false);
          return false;
        }
      } catch (err) {
        context.commit('SET_IS_RADAR_CONTRACT', false);
        return false;
      }
    },
    AUTO_LOGIN_USER(context) {
      context.commit('SET_LOGGED_USER', null);
    },
    LOGOUT(context) {
      try {
        context.commit('SET_LOGGED_USER', null);
        context.commit('SET_TOKEN', null);
        localStorage.removeItem('token');
      }
      catch (err) {
        context.commit('PUSH_ERROR_MESSAGE', err.message);
      }
    },
    CHECK: async (context) => {
      try {
        const authEndpoint = Vue.prototype.$settings.VUE_APP_AUTH_SERVICE_ENDPOINT;
        await axios.get(`${authEndpoint}/auth2/1.1/connect/check`);
        context.commit('SET_CHECK', true);
        let userResponse = await axios.get(API_GET_USER);
        const user = userResponse.data.result;
        context.commit('SET_LOGGED_USER', user);

        if (user.role === WapiRoles.Admin) return true;

        await context.dispatch('CHECK_CONTRACT');
        await context.dispatch('CHECK_RADAR_CONTRACT');
        return true;
      }
      catch (err) {
        context.commit('SET_CHECK', false);
        return false;
      }
    }
  },
  getters: {
    USER: state => {
      return state.user;
    },
    USER_NAME(state) {
      let result = 'UNAUTHORIZED';
      if (state.user.name) {
        result = state.user.name;
      }
      return result;
    },
    IS_LOGGED_IN(state) {
      return state.user !== null;
    },
    IS_ADMIN(state) {
      return state.user ?.role === 'admin';
    },
    IS_AUTH_USER(state) {
      return state.user ?.role === 'authUser';
    },
    CHECK(state) {
      return state.check;
    },
    TOKEN(state) {
      return state.token;
    },
    IS_RADAR_CONTRACT(state) {
      return state.isRadarContract;
    },
    IS_CONTRACT(state) {
      return state.isContract;
    },
  },

}